import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import CategorySection from '@/components/feature/CategorySection';
import ContentSection from '@/components/feature/ContentSection';
import TrustSection from '@/components/feature/TrustSection';
import CTASection from '@/components/feature/CTASection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <ContentSection />
        <TrustSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}